import { render } from "./productChannelList.vue?vue&type=template&id=0478a5f5&scoped=true"
import script from "./productChannelList.vue?vue&type=script&lang=js"
export * from "./productChannelList.vue?vue&type=script&lang=js"

import "./productChannelList.vue?vue&type=style&index=0&id=0478a5f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0478a5f5"],['__file',"src/views/marketing/productChannelList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0478a5f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0478a5f5', __exports__)) {
    api.reload('0478a5f5', __exports__)
  }
  
  module.hot.accept("./productChannelList.vue?vue&type=template&id=0478a5f5&scoped=true", () => {
    api.rerender('0478a5f5', render)
  })

}


export default __exports__